import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT } from '@sona/angular-util-environment';

/**
 * Intercepts calls to `/api` and points them to the correct API URL.
 *
 * @param apiSegment - The starting segment of the API URL. Only requests starting with this segment will be intercepted
 */
export const apiInterceptor: (apiSegment: string) => HttpInterceptorFn =
    (apiSegment: string) => (req, next) => {
        if (!req.url.startsWith(apiSegment)) {
            return next(req);
        }

        const { apiUrl } = inject(ENVIRONMENT);

        return next(
            req.clone({
                url: `${apiUrl}/${req.url.substring(apiSegment.length + 1)}`
                // TODO: once we let tthe user select organizations, add this:
                // headers: req.headers.set('X-Organization-ID', orgId)
            })
        );
    };
